import React from 'react';

const DeleteConfirmDialog = ({ isOpen, onClose, onConfirm, sessionName }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content delete-confirm-modal">
        <h2>删除会话</h2>
        <p className="delete-message">
          确定要删除会话 "{sessionName}" 吗？此操作无法撤销。
        </p>
        <div className="modal-actions">
          <button type="button" className="cancel-btn" onClick={onClose}>
            取消
          </button>
          <button 
            type="button" 
            className="delete-confirm-btn"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            删除
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmDialog; 